import { useCsValue } from "../useCsValue";
import { useConfigurationInfo } from "./useConfigurationInfo";
export function useConfigurationValueInfo() {
    var _a, _b;
    const configurationValue = useCsValue();
    return useConfigurationInfo((_a = configurationValue.properties) !== null && _a !== void 0 ? _a : undefined, (_b = configurationValue.attachments) !== null && _b !== void 0 ? _b : undefined);
}
//# sourceMappingURL=useConfigurationValueInfo.js.map